import { useEffect } from 'react';

import { StepKeyService } from '../../../../services/stepKeyService';

type TaskRpnParams = {
	stressLevelId?: string;
	frequencyId?: string;
	totalTaskDurationId?: string;
	currentTaskRpn?: number;
	stepKeyService: StepKeyService;
	formPath: (string | number)[];
	setFieldValue: (name: (string | number)[], value: unknown) => void;
	setTaskRPN: (value: number) => void;
};

export function useStepKeyTaskRpn({
	stressLevelId,
	frequencyId,
	totalTaskDurationId,
	currentTaskRpn,
	stepKeyService,
	formPath,
	setFieldValue,
	setTaskRPN
}: TaskRpnParams) {
	useEffect(() => {
		const task_rpn = stepKeyService.calculateTaskRPN(
			stressLevelId || '',
			frequencyId || '',
			totalTaskDurationId || ''
		);
		const nextValue = task_rpn ?? 0;
		if (currentTaskRpn === nextValue) {
			return;
		}
		setFieldValue(formPath, nextValue);
		setTaskRPN(task_rpn || 0);
	}, [
		stressLevelId,
		frequencyId,
		totalTaskDurationId,
		currentTaskRpn,
		stepKeyService,
		formPath,
		setFieldValue,
		setTaskRPN
	]);
}
